export default "__VITE_ASSET__59d5dcff__"